import { surChargeTypeDropdownOption, uomDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { ProposalCopyingForRecalConstant } from "presentation/constant/ProposalCopyingForRecal/ProposalCopyingForRecalConstant";
import { standardProposalTierRequiredFieldList } from "presentation/constant/StandardProposal/StandardProposalConstant";
import { useStandardProposalVM } from "presentation/hook/StandardProposal/useStandardProposalVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useStandardProposalTracked } from "presentation/store/StandardProposal/StandardProposalProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";
import { memo, useCallback, useMemo } from "react";
import { FieldType, IconButton, IFieldValue } from "veronica-ui-component/dist/component/core";
import { SidebarActionCross, Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";


const ProposalCopyTariffItemTierEditPanel = () => {
    const SCREEN_CONSTANT = ProposalCopyingForRecalConstant.Table;
    const [standardProposalState] = useStandardProposalTracked();
    const standardProposalVM = useStandardProposalVM();
    const { currentEditTariffItemTier, isShowCopyEditTierPanel, stdProposalState } = standardProposalState;
    const { isSaveClicked, allFormState } = stdProposalState;
    const messageBarVM = useMessageBarVM();

    const handleSave = useCallback(() => {
        // if (currentEditTariffItemTier.minimum === null) {
        //     messageBarVM.showError("MINIMUM RATE is mandatory.");
        //     return;
        // }
        // if (currentEditTariffItemTier.rate === null) {
        //     messageBarVM.showError("RATE is mandatory.");
        //     return;
        // }
        // if (!currentEditTariffItemTier.uom) {
        //     messageBarVM.showError("UOM is mandatory.");
        //     return;
        // }
        // if (!currentEditTariffItemTier.forevery) {
        //     messageBarVM.showError("FOR EVERY is mandatory.");
        //     return;
        // }
        // if (!currentEditTariffItemTier.cycle) {
        //     messageBarVM.showError("CYCLE is mandatory.");
        //     return;
        // }
        if (Number(currentEditTariffItemTier.minimum) > Number(currentEditTariffItemTier.rate)) {
            messageBarVM.showError("The Minimum should not be larger than Rate.");
            return;
        }
        if ((!currentEditTariffItemTier.surcharge && currentEditTariffItemTier.surchargeType)
            || (currentEditTariffItemTier.surcharge && !currentEditTariffItemTier.surchargeType)) {
            messageBarVM.showError("Please input SURCHARGE and  SURCHARGE TYPE together");
            return;
        }
        if ((!currentEditTariffItemTier.additionalUom && currentEditTariffItemTier.additionalRate)
            || (currentEditTariffItemTier.additionalUom && !currentEditTariffItemTier.additionalRate)) {
            messageBarVM.showError("Please input ADDITIONAL UOM and  ADDITIONAL RATE together");
            return;
        }
        if (Number(currentEditTariffItemTier.rate) > Number(99999999.00) || Number(currentEditTariffItemTier.rate) < Number(-99999999.00)) {
            messageBarVM.showError("RATE should be range from -99,999,999.00 to 99,999,999.00.");
            return;
        }
        if (Number(currentEditTariffItemTier.minimum) > Number(99999999.00) || Number(currentEditTariffItemTier.minimum) < Number(-99999999.00)) {
            messageBarVM.showError("MINIMUM RATE should be range from -99,999,999.00 to 99,999,999.00.");
            return;
        }
        if (Number(currentEditTariffItemTier.additionalRate) > Number(99999999.00) || Number(currentEditTariffItemTier.additionalRate) < Number(-99999999.00)) {
            messageBarVM.showError("ADDITIONAL RATE should be range from -99,999,999.00 to 99,999,999.00.");
            return;
        }
        if (Number(currentEditTariffItemTier.surcharge) > Number(99999999.00) || Number(currentEditTariffItemTier.surcharge) < Number(0)) {
            messageBarVM.showError("SURCHARGE should be range from 0.00 to 99,999,999.00.");
            return;
        }
        standardProposalVM.onSaveClicked();
        standardProposalVM.onTempSaveCopyItemTier(currentEditTariffItemTier);
        return;
    }, [currentEditTariffItemTier, messageBarVM, standardProposalVM]);

    const handleCancel = useCallback(() => {
        standardProposalVM.cancelEdit();
    }, [standardProposalVM]);

    const onNumberFieldChange = useCallback((e: any, fieldName: string, fieldValue: any) => {
        standardProposalVM.onTierFieldChange(fieldName, fieldValue);
    }, [standardProposalVM]);

    const memoCycle = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "10px" }}>
            {/* <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={currentEditTariffItemTier?.cycle?.toString() || ''}
                fieldValue={currentEditTariffItemTier?.cycle?.toString()}
                fieldLabel={SCREEN_CONSTANT.CYCLE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'cycle'}
                maxLength={10}
                requiredFieldList={standardProposalTierRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    standardProposalVM.onTierFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} /> */}
            <NumberInputComponent
                label={SCREEN_CONSTANT.CYCLE}
                maxLength={10}
                fieldName={"cycle"}
                value={currentEditTariffItemTier?.cycle ?? ''}
                errorMessage={allFormState ? allFormState["cycle"] ?? "" : ""}
                allowNegative={false}
                disabled={false}
                decimalPlaces={0}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [SCREEN_CONSTANT.CYCLE, allFormState, currentEditTariffItemTier?.cycle, onNumberFieldChange])

    const memoForEvery = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "10px" }}>
            {/* <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={currentEditTariffItemTier?.forevery?.toString() || ''}
                fieldValue={currentEditTariffItemTier?.forevery?.toString()}
                fieldLabel={SCREEN_CONSTANT.FOR_EVERY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'forevery'}
                maxLength={10}
                requiredFieldList={standardProposalTierRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    standardProposalVM.onTierFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} /> */}
            <NumberInputComponent
                label={SCREEN_CONSTANT.FOR_EVERY}
                maxLength={10}
                fieldName={"forevery"}
                value={currentEditTariffItemTier?.forevery ?? ''}
                errorMessage={allFormState ? allFormState["forevery"] ?? "" : ""}
                allowNegative={false}
                disabled={false}
                decimalPlaces={0}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [SCREEN_CONSTANT.FOR_EVERY, allFormState, currentEditTariffItemTier?.forevery, onNumberFieldChange])

    const memoUom = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "10px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={currentEditTariffItemTier?.uom || ''}
                fieldValue={currentEditTariffItemTier?.uom}
                fieldLabel={SCREEN_CONSTANT.UOM}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'uom'}
                maxLength={60}
                options={uomDropdownOption}
                requiredFieldList={standardProposalTierRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    standardProposalVM.onTierFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.UOM, allFormState, currentEditTariffItemTier?.uom, isSaveClicked, standardProposalVM])

    const memoRate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "10px" }}>
            <NumberInputComponent
                label={SCREEN_CONSTANT.RATE}
                maxLength={12}
                fieldName={"rate"}
                value={currentEditTariffItemTier?.rate ?? ''}
                errorMessage={allFormState ? allFormState["rate"] ?? "" : ""}
                allowNegative={true}
                disabled={false}
                decimalPlaces={2}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [SCREEN_CONSTANT.RATE, allFormState, currentEditTariffItemTier?.rate, onNumberFieldChange])

    const memoMinimun = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "10px" }}>
            <NumberInputComponent
                label={SCREEN_CONSTANT.MINIMUM}
                maxLength={12}
                fieldName={"minimum"}
                value={currentEditTariffItemTier?.minimum ?? ''}
                errorMessage={allFormState ? allFormState["minimum"] ?? "" : ""}
                disabled={false}
                allowNegative={true}
                decimalPlaces={2}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [SCREEN_CONSTANT.MINIMUM, allFormState, currentEditTariffItemTier?.minimum, onNumberFieldChange])

    const memosurCharge = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "10px" }}>
            <NumberInputComponent
                label={SCREEN_CONSTANT.SURCHARGE}
                maxLength={12}
                fieldName={"surcharge"}
                value={currentEditTariffItemTier?.surcharge ?? ''}
                errorMessage={allFormState ? allFormState["surcharge"] ?? "" : ""}
                disabled={false}
                allowNegative={true}
                decimalPlaces={2}
                optional={true}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [SCREEN_CONSTANT.SURCHARGE, allFormState, currentEditTariffItemTier?.surcharge, onNumberFieldChange])

    const memoSurChargeType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "10px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={currentEditTariffItemTier?.surchargeType || ''}
                fieldValue={currentEditTariffItemTier?.surchargeType}
                fieldLabel={SCREEN_CONSTANT.SURCHARGE_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'surchargeType'}
                maxLength={60}
                options={surChargeTypeDropdownOption}
                requiredFieldList={standardProposalTierRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    standardProposalVM.onTierFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.SURCHARGE_TYPE, allFormState, currentEditTariffItemTier?.surchargeType, isSaveClicked, standardProposalVM])

    const memoAdditionalRate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "10px" }}>
            <NumberInputComponent
                label={SCREEN_CONSTANT.ADDITIONAL_RATE}
                maxLength={12}
                fieldName={"additionalRate"}
                value={currentEditTariffItemTier?.additionalRate ?? ''}
                errorMessage={allFormState ? allFormState["rate"] ?? "" : ""}
                disabled={false}
                allowNegative={true}
                decimalPlaces={2}
                optional={true}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [SCREEN_CONSTANT.ADDITIONAL_RATE, allFormState, currentEditTariffItemTier?.additionalRate, onNumberFieldChange])

    const memoAdditionalUom = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "10px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={currentEditTariffItemTier?.additionalUom || ''}
                fieldValue={currentEditTariffItemTier?.additionalUom}
                fieldLabel={SCREEN_CONSTANT.ADDITIONAL_UOM}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'additionalUom'}
                maxLength={60}
                options={uomDropdownOption}
                requiredFieldList={standardProposalTierRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    standardProposalVM.onTierFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.ADDITIONAL_UOM, allFormState, currentEditTariffItemTier?.additionalUom, isSaveClicked, standardProposalVM])

    return <div className="side-form-content-left-wrapper" style={{ height: "40vh", maxHeight: "40vh", overflow: "visible", padding: "5px" }}>

        <div className={'flex-row'}>
            <div className={'flex-row-item flex-row-item-full-width'}>
                <Sidebarheader>
                    <SidebarTitle>
                        {isShowCopyEditTierPanel && "Edit " + SCREEN_CONSTANT.TIER_VALUE}
                    </SidebarTitle>
                    <SidebarActionCross>
                        <IconButton
                            fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={handleCancel} />
                        <IconButton
                            fileName="Icon-tick" size="medium" toolTipText='Save' toolTipArrow={false} onClick={handleSave} />
                    </SidebarActionCross>
                </Sidebarheader>
            </div>
        </div>

        <div className={'add-edit-form'} style={{ height: '30vh', maxHeight: '30vh', overflow: 'visible', zIndex: '100' }}>
            <div className="flex-row-auto">
                <div className={'flex-row-item'}>
                    <CriteriaItemContainer>
                        {memoCycle}
                        {memoForEvery}
                        {memoUom}
                    </CriteriaItemContainer>
                    <CriteriaItemContainer>
                        {memoRate}
                        {memoMinimun}
                        {memosurCharge}
                    </CriteriaItemContainer>
                    <CriteriaItemContainer>
                        {memoSurChargeType}
                        {memoAdditionalRate}
                        {memoAdditionalUom}
                    </CriteriaItemContainer>
                </div>
            </div>
        </div>
    </div>;
}

export default memo(ProposalCopyTariffItemTierEditPanel);